import React, { useState } from 'react';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'react-headless-accordion';
import { IoIosArrowBack } from 'react-icons/io';

const Accordion1 = ({ type }) => {
    const [rotationState, setRotationState] = useState(false);

    const toggleRotation = () => {
        setRotationState(!rotationState);
    };

    const accordionTransitionDuration = 500; // Set the same duration as the accordion transition

    const accordionClass = () => {
        switch (type) {
            case 'rounded':
                return 'max-w-[500px] mx-auto border-accordionBorderColor bg-gradient-to-r from-accordionMainColor to-accordionSecondaryColor rounded-2xl border-[4px] shadow-lg';
            case 'rectangle':
                return 'max-w-[500px] mx-auto border-accordionBorderColor rounded-none bg-gradient-to-r from-accordionMainColor to-accordionSecondaryColor border-[4px] shadow-lg';
            default:
                return '';
        }
    };

    return (
        <div className='mt-6 mx-auto px-4'>
            <Accordion
                className={accordionClass()}
                transition={{ duration: `${accordionTransitionDuration}ms`, timingFunction: 'cubic-bezier(0, 0, 0.2, 1)' }}
            >
                <AccordionItem>
                    <AccordionHeader
                        className='bg-gradient-to-r from-accordionMainColor to-accordionSecondaryColor items-center text-accordion_headerColor flex p-4 w-full justify-between rounded-2xl'
                        onClick={toggleRotation}
                    >
                        <IoIosArrowBack
                            className={`${rotationState ? 'rotate-90' : ''} text-2xl text-accordion_iconColor`}
                            style={{ transition: `transform 0.5s ease-in-out` }}
                        />
                        <h3 className='text-2xl font-bold'>קורס בסיס בוטיק לאיפור קבוע</h3>
                    </AccordionHeader>

                    <AccordionBody>
                        <div dir='rtl' className='text-accordionTextColor text-right font-medium p-4 rounded-b-2xl'>

                            <p className='text-xl text-blue-200 font-bold'>
                                עד 4 תלמידות בלבד!
                            </p>
                            <p className='text-lg font-bold text-yellow-200'>
                                הקורס האינפורמטיבי ביותר
                            </p>
                            <p className='text-lg font-bold text-pink-200'>
                                ידע שלא יסולא בפז בתחום PM ובניית מותג.
                            </p>

                            <ul className='mr-5 '>
                                <li className='list-disc font-bold mt-2'>
                                    יחס אישי וצמוד
                                </li>
                                <li className='list-disc font-bold mt-2'>
                                    תרגול ופרקטיקה בהשגחה מלאה
                                </li>
                                <li className='list-disc font-bold mt-2'>
                                    זמינות ונגישות בכל שלבי הקורס
                                </li>
                            </ul>
                            <p className='text-xl text-blue-200 font-bold mt-8'>
                                מה כלול בתכנית הלימודים?
                            </p>
                            <ul className='mr-5 '>
                                <li className='list-disc font-bold mt-2'>
                                    גבות celebrity brow
                                </li>
                                <li className='list-disc font-bold mt-2'>
                                    עניים sexy eyes 👀
                                </li>
                                <li className='list-disc font-bold mt-2'>
                                    שפתיים silk lips 💋
                                </li>
                            </ul>

                            <p className='text-xl text-blue-200 font-bold mt-8'>
                                עם מה תצאי מהקורס שלנו?
                            </p>
                            <ul className='mr-5 '>

                                <li className='list-disc font-bold mt-2'>
                                    ערכת ציוד מקצועית שתלווה אותך בהמשך הדרך,<br />
                                    ומתאימה לתחילת עבודה מיידית
                                </li>
                                <li className='list-disc font-bold mt-2'>
                                    3 תעודות מקצועיות
                                </li>
                                <li className='list-disc font-bold mt-2'>
                                    תיק עבודות (צילומים שייעשו במשך הקורס)
                                </li>
                                <li className='list-disc font-bold mt-2'>
                                    חומרי בסיס
                                </li>
                                <li className='list-disc font-bold mt-2'>
                                    קורס מתקדם ליצירת תמונות יפות ברשתות חברתיות (זווית/תאורה/קולאז'ים/וידאו) ואיך לפרסם
                                </li>
                                <li className='list-disc font-bold mt-2'>
                                    תמיכה גם אחרי סיום הקורס
                                </li>
                                <li className='list-disc font-bold mt-2'>
                                    גישת למידה אישית
                                </li>
                            </ul>
                            <p className='text-lg font-bold text-yellow-200 mt-4'>
                                לאחר סיום הקורס לא יישארו לך חששות ושאלות! 💫
                            </p>
                        </div>
                    </AccordionBody>
                </AccordionItem>
            </Accordion>
        </div>
    );
};

export default Accordion1;
